import {
  ActivityIcon,
  BookOpenIcon,
  ClipboardCheckIcon,
  DumbbellIcon,
  FileTextIcon,
  ListChecksIcon,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export interface KitItem {
  icon: LucideIcon
  title: string
  description: string
}

export const kitContents: KitItem[] = [
  { icon: BookOpenIcon, title: '6 Kompletnych Tomów', description: 'Od podstaw do wysokiego poziomu' },
  { icon: FileTextIcon, title: 'Program 360+ stron', description: 'Pełny i uporządkowany' },
  { icon: ListChecksIcon, title: 'Sesje krok po kroku', description: '120+ gotowych treningów' },
  { icon: ActivityIcon, title: 'Baza ćwiczeń', description: 'Z diagramami boiska' },
  { icon: DumbbellIcon, title: 'Przygotowanie fizyczne', description: 'I zapobieganie kontuzjom' },
  { icon: ClipboardCheckIcon, title: 'Testy i ocena', description: 'Pomiar postępów zawodnika' },
]
